module.exports = __webpack_public_path__ + "img/74.af558750.jpg";